import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from '../../shared/services/user.service';
import { UtilityService } from '../../shared/services/utility.service';

@Component({
  selector: 'app-the-funstudio',
  templateUrl: './the-funstudio.component.html',
  styleUrls: ['./the-funstudio.component.scss']
})
export class TheFunstudioComponent implements OnInit, OnDestroy {
  webAlias: string = '';

  /** Video 1: Vimeo embed */
  video1ThumbnailUrl = 'assets/funstudios/VIDEO1THUMBNAIL.png';
  video1VideoUrl: SafeResourceUrl;
  video1Playing = false;
  /** Video 2: Vimeo embed */
  video2ThumbnailUrl = 'assets/funstudios/VIDEO2THUMBNAIL.png';
  video2VideoUrl: SafeResourceUrl;
  video2Playing = false;
  /** Video 3: Vimeo embed */
  video3ThumbnailUrl = 'assets/funstudios/VIDEO3THUMBNAIL.png';
  video3VideoUrl: SafeResourceUrl;
  video3Playing = false;

  constructor(
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private utilityService: UtilityService
  ) {
    // Sanitize Vimeo URLs for iframes (hide title, byline, and portrait)
    this.video1VideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://player.vimeo.com/video/1163350073?badge=0&autopause=0&title=0&byline=0&portrait=0'
    );
    this.video2VideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://player.vimeo.com/video/1156932382?h=5150e68f22&title=0&byline=0&portrait=0'
    );
    this.video3VideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://player.vimeo.com/video/1161335122?title=0&byline=0&portrait=0'
    );
  }

  playVideo1(): void {
    this.video1Playing = true;
  }

  playVideo2(): void {
    this.video2Playing = true;
  }

  playVideo3(): void {
    this.video3Playing = true;
  }

  // Base href is already set to /pokey (or /www), so navigate to join route only
  get joinUrl(): string[] {
    return ['/join'];
  }

  ngOnInit(): void {
    this.utilityService.showSimplifiedheader(true);

    const fullPath = window.location.pathname;
    const pathSegments = fullPath.split('/').filter(segment => segment && !segment.includes('?'));

    if (pathSegments.length > 0 && pathSegments[0] !== 'thefunstudio') {
      this.webAlias = pathSegments[0];
    }

    if (!this.webAlias && this.userService?.userServiceModal?.enrollerInfo) {
      const info = this.userService.userServiceModal.enrollerInfo;
      if (info.WebAlias) this.webAlias = info.WebAlias;
    }

    if (!this.webAlias) {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      if (userData.WebAlias) this.webAlias = userData.WebAlias;
    }
  }

  ngOnDestroy(): void {
    this.utilityService.showSimplifiedheader(false);
  }
}
